// extracted by mini-css-extract-plugin
export default {"root":"Primary_root__9iZcG Button_base__ncFXu Button_root__dDO5g","transparent":"Primary_transparent__4eUfP","white":"Primary_white__NZhW0","blue":"Primary_blue__QqjuN"};